export const CREATE_CARE_PLAN_REQUEST = "CREATE_CARE_PLAN_REQUEST";
export const CREATE_CARE_PLAN_SUCCESS = "CREATE_CARE_PLAN_SUCCESS";
export const CREATE_CARE_PLAN_FAIL = "CREATE_CARE_PLAN_FAIL";
export const RESET_CREATE_CARE_PLAN = "RESET_CREATE_CARE_PLAN";

export const GET_CARE_PLAN_REQUEST = "GET_CARE_PLAN_REQUEST";
export const GET_CARE_PLAN_SUCCESS = "GET_CARE_PLAN_SUCCESS";
export const GET_CARE_PLAN_FAIL = "GET_CARE_PLAN_FAIL";

export const GET_PLAN_ASSESSMENT_REQUEST = "GET_PLAN_ASSESSMENT_REQUEST";
export const GET_PLAN_ASSESSMENT_SUCCESS = "GET_PLAN_ASSESSMENT_SUCCESS";
export const GET_PLAN_ASSESSMENT_FAIL = "GET_PLAN_ASSESSMENT_FAIL";

export const GET_CARE_PLAN_SUMMARY_REQUEST = "GET_CARE_PLAN_SUMMARY_REQUEST";
export const GET_CARE_PLAN_SUMMARY_SUCCESS = "GET_CARE_PLAN_SUMMARY_SUCCESS";
export const GET_CARE_PLAN_SUMMARY_FAIL = "GET_CARE_PLAN_SUMMARY_FAIL";

export const GET_PLAN_VERSIONS_LIST_REQUEST = "GET_PLAN_VERSIONS_LIST_REQUEST";
export const GET_PLAN_VERSIONS_LIST_SUCCESS = "GET_PLAN_VERSIONS_LIST_SUCCESS";
export const GET_PLAN_VERSIONS_LIST_FAIL = "GET_PLAN_VERSIONS_LIST_FAIL";

export const CREATE_PLAN_ASSESSMENT_REQUEST = "CREATE_PLAN_ASSESSMENT_REQUEST";
export const CREATE_PLAN_ASSESSMENT_SUCCESS = "CREATE_PLAN_ASSESSMENT_SUCCESS";
export const CREATE_PLAN_ASSESSMENT_FAIL = "CREATE_PLAN_ASSESSMENT_FAIL";
export const RESET_CREATE_PLAN_ASSESSMENT = "RESET_CREATE_PLAN_ASSESSMENT";

export const UPDATE_PLAN_ASSESSMENT_REQUEST = "UPDATE_PLAN_ASSESSMENT_REQUEST";
export const UPDATE_PLAN_ASSESSMENT_SUCCESS = "UPDATE_PLAN_ASSESSMENT_SUCCESS";
export const UPDATE_PLAN_ASSESSMENT_FAIL = "UPDATE_PLAN_ASSESSMENT_FAIL";
export const RESET_UPDATE_PLAN_ASSESSMENT = "RESET_UPDATE_PLAN_ASSESSMENT";

export const CREATE_PLAN_PROBLEM_REQUEST = "CREATE_PLAN_PROBLEM_REQUEST";
export const CREATE_PLAN_PROBLEM_SUCCESS = "CREATE_PLAN_PROBLEM_SUCCESS";
export const CREATE_PLAN_PROBLEM_FAIL = "CREATE_PLAN_PROBLEM_FAIL";
export const RESET_CREATE_PLAN_PROBLEM = "RESET_CREATE_PLAN_PROBLEM";

export const GET_PLAN_PROBLEMS_LIST_REQUEST = "GET_PLAN_PROBLEMS_LIST_REQUEST";
export const GET_PLAN_PROBLEMS_LIST_SUCCESS = "GET_PLAN_PROBLEMS_LIST_SUCCESS";
export const GET_PLAN_PROBLEMS_LIST_FAIL = "GET_PLAN_PROBLEMS_LIST_FAIL";

export const EDIT_PLAN_PROBLEM_REQUEST = "EDIT_PLAN_PROBLEM_REQUEST";
export const EDIT_PLAN_PROBLEM_SUCCESS = "EDIT_PLAN_PROBLEM_SUCCESS";
export const EDIT_PLAN_PROBLEM_FAIL = "EDIT_PLAN_PROBLEM_FAIL";
export const RESET_EDIT_PLAN_PROBLEM = "RESET_EDIT_PLAN_PROBLEM";

export const CREATE_GOAL_PLAN_REQUEST = "CREATE_GOAL_PLAN_REQUEST";
export const CREATE_GOAL_PLAN_SUCCESS = "CREATE_GOAL_PLAN_SUCCESS";
export const CREATE_GOAL_PLAN_FAIL = "CREATE_GOAL_PLAN_FAIL";
export const RESET_CREATE_GOAL_PLAN = "RESET_CREATE_GOAL_PLAN";

export const GET_PLAN_GOALS_LIST_REQUEST = "GET_PLAN_GOALS_LIST_REQUEST";
export const GET_PLAN_GOALS_LIST_SUCCESS = "GET_PLAN_GOALS_LIST_SUCCESS";
export const GET_PLAN_GOALS_LIST_FAIL = "GET_PLAN_GOALS_LIST_FAIL";

export const EDIT_GOAL_PLAN_REQUEST = "EDIT_GOAL_PLAN_REQUEST";
export const EDIT_GOAL_PLAN_SUCCESS = "EDIT_GOAL_PLAN_SUCCESS";
export const EDIT_GOAL_PLAN_FAIL = "EDIT_GOAL_PLAN_FAIL";
export const RESET_EDIT_GOAL_PLAN = "RESET_EDIT_GOAL_PLAN";

export const CREATE_PLAN_INTERVENTION_REQUEST =
  "CREATE_PLAN_INTERVENTION_REQUEST";
export const CREATE_PLAN_INTERVENTION_SUCCESS =
  "CREATE_PLAN_INTERVENTION_SUCCESS";
export const CREATE_PLAN_INTERVENTION_FAIL = "CREATE_PLAN_INTERVENTION_FAIL";
export const RESET_CREATE_PLAN_INTERVENTION = "RESET_CREATE_PLAN_INTERVENTION";

export const GET_PLAN_INTERVENTIONS_LIST_REQUEST =
  "GET_PLAN_INTERVENTIONS_LIST_REQUEST";
export const GET_PLAN_INTERVENTIONS_LIST_SUCCESS =
  "GET_PLAN_INTERVENTIONS_LIST_SUCCESS";
export const GET_PLAN_INTERVENTIONS_LIST_FAIL =
  "GET_PLAN_INTERVENTIONS_LIST_FAIL";

export const EDIT_PLAN_INTERVENTION_REQUEST = "EDIT_PLAN_INTERVENTION_REQUEST";
export const EDIT_PLAN_INTERVENTION_SUCCESS = "EDIT_PLAN_INTERVENTION_SUCCESS";
export const EDIT_PLAN_INTERVENTION_FAIL = "EDIT_PLAN_INTERVENTION_FAIL";
export const RESET_EDIT_PLAN_INTERVENTION = "RESET_EDIT_PLAN_INTERVENTION";

export const CREATE_MEDICATION_PLAN_REQUEST = "CREATE_MEDICATION_PLAN_REQUEST";
export const CREATE_MEDICATION_PLAN_SUCCESS = "CREATE_MEDICATION_PLAN_SUCCESS";
export const CREATE_MEDICATION_PLAN_FAIL = "CREATE_MEDICATION_PLAN_FAIL";
export const RESET_CREATE_MEDICATION_PLAN = "RESET_CREATE_MEDICATION_PLAN";

export const GET_PLAN_MEDICATIONS_LIST_REQUEST =
  "GET_PLAN_MEDICATIONS_LIST_REQUEST";
export const GET_PLAN_MEDICATIONS_LIST_SUCCESS =
  "GET_PLAN_MEDICATIONS_LIST_SUCCESS";
export const GET_PLAN_MEDICATIONS_LIST_FAIL = "GET_PLAN_MEDICATIONS_LIST_FAIL";

export const EDIT_MEDICATION_PLAN_REQUEST = "EDIT_MEDICATION_PLAN_REQUEST";
export const EDIT_MEDICATION_PLAN_SUCCESS = "EDIT_MEDICATION_PLAN_SUCCESS";
export const EDIT_MEDICATION_PLAN_FAIL = "EDIT_MEDICATION_PLAN_FAIL";
export const RESET_EDIT_MEDICATION_PLAN = "RESET_EDIT_MEDICATION_PLAN";

export const CREATE_PLAN_MEMBER_REQUEST = "CREATE_PLAN_MEMBER_REQUEST";
export const CREATE_PLAN_MEMBER_SUCCESS = "CREATE_PLAN_MEMBER_SUCCESS";
export const CREATE_PLAN_MEMBER_FAIL = "CREATE_PLAN_MEMBER_FAIL";
export const RESET_CREATE_PLAN_MEMBER = "RESET_CREATE_PLAN_MEMBER";

export const GET_PLAN_MEMBERS_LIST_REQUEST = "GET_PLAN_MEMBERS_LIST_REQUEST";
export const GET_PLAN_MEMBERS_LIST_SUCCESS = "GET_PLAN_MEMBERS_LIST_SUCCESS";
export const GET_PLAN_MEMBERS_LIST_FAIL = "GET_PLAN_MEMBERS_LIST_FAIL";

export const EDIT_PLAN_MEMBER_REQUEST = "EDIT_PLAN_MEMBER_REQUEST";
export const EDIT_PLAN_MEMBER_SUCCESS = "EDIT_PLAN_MEMBER_SUCCESS";
export const EDIT_PLAN_MEMBER_FAIL = "EDIT_PLAN_MEMBER_FAIL";
export const RESET_EDIT_PLAN_MEMBER = "RESET_EDIT_PLAN_MEMBER";

export const CREATE_PLAN_SOCIAL_CONTEXT_REQUEST =
  "CREATE_PLAN_SOCIAL_CONTEXT_REQUEST";
export const CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS =
  "CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS";
export const CREATE_PLAN_SOCIAL_CONTEXT_FAIL =
  "CREATE_PLAN_SOCIAL_CONTEXT_FAIL";
export const RESET_CREATE_PLAN_SOCIAL_CONTEXT =
  "RESET_CREATE_PLAN_SOCIAL_CONTEXT";

export const GET_PLAN_SOCIAL_CONTEXT_REQUEST =
  "GET_PLAN_SOCIAL_CONTEXT_REQUEST";
export const GET_PLAN_SOCIAL_CONTEXT_SUCCESS =
  "GET_PLAN_SOCIAL_CONTEXT_SUCCESS";
export const GET_PLAN_SOCIAL_CONTEXT_FAIL = "GET_PLAN_SOCIAL_CONTEXT_FAIL";

export const EDIT_PLAN_SOCIAL_CONTEXT_REQUEST =
  "EDIT_PLAN_SOCIAL_CONTEXT_REQUEST";
export const EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS =
  "EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS";
export const EDIT_PLAN_SOCIAL_CONTEXT_FAIL = "EDIT_PLAN_SOCIAL_CONTEXT_FAIL";
export const RESET_EDIT_PLAN_SOCIAL_CONTEXT = "RESET_EDIT_PLAN_SOCIAL_CONTEXT";

export const SAVE_PLAN_VERSION_REQUEST = "SAVE_PLAN_VERSION_REQUEST";
export const SAVE_PLAN_VERSION_SUCCESS = "SAVE_PLAN_VERSION_SUCCESS";
export const SAVE_PLAN_VERSION_FAIL = "SAVE_PLAN_VERSION_FAIL";
export const RESET_SAVE_PLAN_VERSION = "RESET_SAVE_PLAN_VERSION";

export const SET_EDIT_CARE_PLAN = "SET_EDIT_CARE_PLAN";
